module.exports = __webpack_public_path__ + "static/media/razorpayZWZlogo1.e488e8ba.png";